import axios from "axios";
//url of movie database:
const instance = axios.create({
    baseURL:"https://api.themoviedb.org/3",

});
export default instance